module.exports = __webpack_public_path__ + "static/media/AdminNómina_ExcepciónDíasHoras.ff7e0aa5.svg";